import { parseNonNegativeDecimal } from 'utils/numberUtils/decimalInput'

// The backend accepts a volume of at most 8 whole digits and 2 decimals (numeric(10,2)).
const BID_VOLUME_LIMIT = 1e8
const BID_VOLUME_DECIMALS = 2

function isWithinBackendPrecision(value: number): boolean {
  return value < BID_VOLUME_LIMIT && Number(value.toFixed(BID_VOLUME_DECIMALS)) === value
}

export function isBidValueInvalid(rawValue: string): boolean {
  if (rawValue.trim() === '') {
    return false
  }

  const value = parseNonNegativeDecimal(rawValue)
  return value === null || !isWithinBackendPrecision(value)
}

type ConfiguredTag = {
  tag_id: string
  display_name: string
  buy: Record<string, unknown>
  sell: Record<string, unknown>
  enabled?: boolean
}

export type ConfiguredPosition = {
  position_id: string
  display_name?: string
  tags: ConfiguredTag[]
}

export function isConfiguredPositionsValid(positions: unknown): positions is ConfiguredPosition[] {
  if (!Array.isArray(positions)) {
    return false
  }

  return positions.every((position: unknown) => {
    if (typeof position !== 'object' || position === null) {
      return false
    }

    const p = position as Record<string, unknown>

    if (typeof p.position_id !== 'string' || p.position_id === '') {
      return false
    }

    if (!Array.isArray(p.tags)) {
      return false
    }

    return p.tags.every((tag: unknown) => {
      if (typeof tag !== 'object' || tag === null) {
        return false
      }

      const t = tag as Record<string, unknown>

      return (
        typeof t.tag_id === 'string' &&
        t.tag_id !== '' &&
        typeof t.display_name === 'string' &&
        typeof t.buy === 'object' &&
        t.buy !== null &&
        !Array.isArray(t.buy) &&
        typeof t.sell === 'object' &&
        t.sell !== null &&
        !Array.isArray(t.sell)
      )
    })
  })
}
